import { render, staticRenderFns } from "./PasswordResetAdmin.vue?vue&type=template&id=52f67f9e&"
import script from "./PasswordResetAdmin.vue?vue&type=script&lang=js&"
export * from "./PasswordResetAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports